module.exports = __webpack_public_path__ + "static/img/hos.b0795ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hos.jpg
// module id = 9NAW
// module chunks = 0